import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06","key":"svg-0"}],["path",{"d":"M15 19l2 2l4 -4","key":"svg-1"}]]

const IconShieldCheck = createReactComponent('outline', 'shield-check', 'ShieldCheck', __iconNode);

export default IconShieldCheck;